export const API_HOST = process.env.VUE_APP_API_HOST || ''
